<template>
    <div class="ProductDetail page" id="ProductDetail">
        <c-header
                :left-arrow="true"
                left-text="返回"
                title="详情页"
        />
        <van-swipe :autoplay="3000" loop v-if="data.banner.length > 0">
            <van-swipe-item v-for="(image, index) in data.banner" :key="index">
                <div class="swiper-img" :style="{'height':height}">
                    <img :src="image" alt="" style="width:100%;height:100%;">
                </div>
            </van-swipe-item>
        </van-swipe>
        <div class="product bg-white padding-30 flex-row margin-bottom-10">
            <div class="avtor-img margin-right-10 border-radius-10">
                <img :src="data.detail.proavtor" alt="" style="width:100%;height:100%;">
            </div>
            <div class="flex-column">
                <span class="margin-bottom-4 font-weight">{{data.detail.productname}}</span>
                <span class="color-666 font-size-24">{{data.detail.brand}}</span>
            </div>
        </div>
        <div class="block padding-30 bg-white">
            <div class="margin-bottom-10" @click="bClick">产品说明书</div>
            <p>{{data.detail.memo}}</p>
            <div class="flex-column">
                <div class="detail-video margin-30 border-radius-10" v-if="data.detail.videourl">
                    <video :src="data.detail.videourl"
                           preload="true"
                           webkit-playsinline="true"
                           x5-video-player-type="h5"
                           x5-video-orientation="portraint"
                           style="width: 100%;height:100%;"
                           controls/>
                </div>
                <div class="detail-img margin-bottom-10 border-radius-10" v-for="(item,index) in data.details" :key="index">
                    <img :src="item" alt="" style="width: 100%;">
                </div>
            </div>
        </div>
        <!--产品信息-->
        <div class="specification bg-white padding-30">
            <div class="margin-bottom-10">产品信息</div>
            <div class="flex-row product-group">
                <div class="item" v-for="(item,index) in data.productList" :key="index" @click="goDetail(item.id)">
                    <div class="img">
                        <img :src="item.proavtor" alt="" style="width:100%;height:100%;">
                    </div>
                    <div class="text-one-line">{{item.productname}}</div>
                    <div class="color-666 font-size-24">{{item.brand}}</div>
                </div>
            </div>
        </div>
        <!--客服-->
        <service-btn/>
        <!--底部栏-->
        <div class="bottom flex-row-between bg-white">
            <div class="left flex-row">
                <van-icon name="wap-home" @click="goHome" size="25"/>
                <div class="margin-left-10">累计观看量：{{data.detail.clicknum}}</div>
            </div>
            <div class="right flex-row">
                喜欢
                <div class="img margin-left-10">
                    <img src="../assets/images/xihuan.png" style="width: 100%;height:100%;" alt="" @click="onClickLove(data.detail.id)" v-if="!data.isLove">
                    <img src="../assets/images/xihuan_sel.png" style="width: 100%;height:100%;" alt="" v-else>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent,reactive,onBeforeMount,computed,onMounted,onUnmounted } from "vue";
    import common from '@/assets/ts/common';
    import { useRouter,useRoute } from 'vue-router';
    import { useModal } from '@/hooks/useModal';
    import { Toast } from 'vant';

    export default defineComponent({
        setup(){
          const { bClick } = useModal();
          const router = useRouter();
          const route = useRoute();
          const data:any = reactive({
            detail:{},
            isLove:false,
            productList:[],
            width:"",
            banner:[],
            scrollToTop:()=>{}
          });

          const height = computed(()=>{
            return (document.body.clientWidth/7 * 6) + 'px';
          });

          onBeforeMount(()=>{
            getData();
            getDataList();
          });

          onMounted(()=>{
            window.addEventListener('scroll', data.scrollToTop)
          });

          onUnmounted(()=>{
            window.removeEventListener('scroll', data.scrollToTop)
          });

          //获取产品列表
          const getDataList = (): void => {
            common.request('post', '/adproduct/getProductAdListInfo')
              .then((res: any) => {
                data.productList = res.data;
              });
          };

          //点赞
          const onClickLove = (id:string) => {
            common.request("post","/adproduct/addProductAdLove",{pid:id})
            .then((res:any)=>{
              data.isLove = true;
              Toast.success(res.message);
            })
          };

          const getData = (id?:string) => {
            Toast.loading({
              message: '加载中...',
              forbidClick: true,
            });
            common.request("post","/adproduct/getProductInfo",{id:id ? id : route.query.id})
            .then((res:any)=>{
              data.detail = res.data;
              data.banner = common.getBanner(data.detail.bannerurl);
              data.details = common.getBanner(data.detail.detailsurl);
              Toast.clear();
            })
            .catch(()=>{
              Toast.clear();
            })
          };

          const goHome = () => {
            router.push("/");
          };

          //跳转详情页
          const goDetail = (id:any):void => {
            /*let ispeed:number = document.documentElement.scrollTop || document.body.scrollTop;
            document.body.scrollTop = (document as any).getElementById("ProductDetail").scrollTop = data.scrollTop + ispeed;*/
            /*let timer = setInterval(() => {
              document.body.scrollTop = (document as any).getElementById("ProductDetail").scrollTop = data.scrollTop + ispeed;
              if (data.scrollTop === 0) {
                clearInterval(timer);
              }
            }, 16);*/
            //getData(id);
            router.push({
              name:"Empty",
              query:{
                id:id,
                name:"ProductDetail"
              },
              replace:true
            });
          };

          return {
            height,
            goDetail,
            data,
            bClick,
            onClickLove,
            goHome
          }
        }
    });
</script>

<style lang="scss" scoped>
    .swiper-img {
        width:100%;
        height:350px;
        border-radius:16px;
        overflow: hidden;
    }
    .product{
        .avtor-img{
            width:140px;
            height:140px;
            overflow: hidden;
        }
    }

    .block{
        margin-bottom:10px;
    }

    .specification{
        margin-bottom:80px;
    }

    .product-group {
        flex-wrap: wrap;
        justify-content: space-between;

        .item {
            width: calc(50% - 15px);
            margin-bottom: 20px;
            .img {
                width: 330px;
                height: 330px;
                border-radius: 16px;
                overflow: hidden;
            }
        }
    }

    .bottom{
        position:fixed;
        bottom:0;
        width:100vw;
        height:90px;
        padding:0 20px;
        align-items: center;
        font-size:28px;
        .right{
            .img{
                width:52px;
                height:48px;
            }
        }
    }
</style>
